function Footer() {
  return (
    <footer className="bg-navy text-white py-8">
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm">© 2025 Exo Contracting Inc. All rights reserved.</p>
        <p className="text-sm mt-2">Contact us: <a href="mailto:info@exocontracting.com" className="hover:text-gold">info@exocontracting.com</a> | (123) 456-7890</p>
        <p className="text-sm mt-1">123 Industrial Way, City, State 12345</p>
      </div>
    </footer>
  );
}

export default Footer;